//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const UseReadonlyDbReplicas: FeatureFlag = {"Id":"UseReadonlyDbReplicas","Label":"Use readonly DB replicas","Impact":"Send certain types of queries to readonly DB replicas.","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
